export default function useRedirectTo404(data: any, loading: boolean) {
  if (!loading && !data) {
    throw new Response('Not Found', { status: 404 });
  }
}
